import { render, staticRenderFns } from "./ImportTrucks.vue?vue&type=template&id=61c15371&scoped=true"
import script from "./ImportTrucks.vue?vue&type=script&lang=js"
export * from "./ImportTrucks.vue?vue&type=script&lang=js"
import style0 from "./ImportTrucks.vue?vue&type=style&index=0&id=61c15371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c15371",
  null
  
)

export default component.exports